import damagedImage from "../../assets/images/Damaged.png";
import averageImage from "../../assets/images/Average.png";
import goodImage from "../../assets/images/Good.png";
import toggleOn from "../../assets/images/btn_on.png";
import toggleOff from "../../assets/images/btn_off.png";

const conditionMap = {
  DAMAGED: damagedImage,
  AVERAGE: averageImage,
  GOOD: goodImage,
};

export const getRoofConditionImage = (condition) => {
  return conditionMap[condition.toUpperCase()];
};

export const getInsuranceBtn = (insuranceStatus) => {
  const toggle = insuranceStatus === "yes" ? toggleOn : toggleOff;
  return toggle;
};
